var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-t-15"},[_c('h4',{staticClass:"text-left m-t-20 m-b-20"},[_vm._v(" Hojas de Ruta ")]),_c('menu-fechas',{attrs:{"model_name":"road_map"}}),_c('select-repartidor'),_c('list-road-maps')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }